"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  submitResults: {
    "id": "submitResults",
    "defaultMessage": "Submit results"
  },
  checklistSummary: {
    "id": "checklistSummary",
    "defaultMessage": "Checklist Summary"
  },
  yourName: {
    "id": "yourName",
    "defaultMessage": "Your name"
  },
  ok: {
    "id": "ok",
    "defaultMessage": "Ok"
  },
  errorSubmittingTitle: {
    "id": "errorSubmittingTitle",
    "defaultMessage": "Unable to submit results"
  },
  errorSubmittingSubtitle: {
    "id": "errorSubmittingSubtitle",
    "defaultMessage": "An error occurred while submitting the results. Please try again."
  },
  errorFetchingChecklist: {
    "id": "errorFetchingChecklist",
    "defaultMessage": "Could not fetch the checklist."
  },
  somethingWentWrong: {
    "id": "pdfErrorHeader",
    "defaultMessage": "Something went wrong"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map